'use client';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import useTenant from 'hooks/useTenant';

const TermsAndPrivacy = () => {
  const tAuth = useTranslations('auth');

  const tenant = useTenant();

  return (
    <div className="mt-4">
      <p className="break-words text-sm text-center leading-relaxed">
        {tAuth('termsPrefixText')}&nbsp;
        <Link
          href={tenant?.termsUrl || '/'}
          target="_blank"
          className="underline underline-offset-4 justify-center border border-transparent whitespace-nowrap"
        >
          {tAuth('termsConditions')}
        </Link>
      </p>
    </div>
  );
};

export default TermsAndPrivacy;
